var React = require('react');
var TeamCompareHeader = require('./TeamCompareHeader.jsx');
var VisCircle = require('./VisCircle.jsx');

var Defending = React.createClass({
    render : function(){
        var home = this.props.tackles.home || {};
        var away = this.props.tackles.away || {};
        var homePercent = home.percent ? [home.percent,100-home.percent] : [0,0];
        var awayPercent = away.percent ? [away.percent,100-away.percent] : [0,0];
        
        return (
            <article className="sub-module equal-height height-reset" style={{"height":" 317px"}}>
				<header className="bordered"><h1>Defending</h1></header>
				<div className="content clear">
								
                    <TeamCompareHeader heading="Tackles made/total" home={this.props.home} away={this.props.away} />
				
                    <div className="chart-container parallel">
        		        <VisCircle colors={this.props.colors} percent={homePercent} home={true} value={home.label} />
                    </div>
                
    				<div className="chart-container parallel">
    				    <VisCircle colors={this.props.colors} percent={awayPercent} value={away.label} />
                    </div>
				</div>
    		</article>
        );
    }
});

module.exports = Defending;


/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/components/rugby/game/Defending.jsx
 **/